import { gql } from "graphql-tag";

export const memberCampaignBanner = gql`
  fragment Become_a_member_campaign_banner on Become_a_memberBodyCampaign_banner {
    type
    primary {
      text
      background_color
      text_color
    }
  }
`;
